<template>
    <div :class="{'container': this.container}">
        <div class="row motionImgPosition">

              <!-- Left Image -->

            <template v-if=imageLeft>
                <div class="col-lg-6">
                    <div class="workout-img">
                        <img :src="imagePath" alt="" />
                    </div>
                </div>

                <div class="col-lg-6 ef-section">
                    <b-row class="mb-3 mt-sm-5" v-if=logo>
                        <b-col class="col-lg-3 col-sm-3">
                            <div class="logo-img-right">
                                <img :src="logoPath" alt="" />
                            </div>
                        </b-col>
                        <div class="col-lg-9 col-sm-9">
                            <div class="section-name-left mt-3">
                                {{ sectionName }}
                            </div>
                        </div>
                    </b-row>


                    <div v-if=!logo class="section-name-left">{{ sectionName }} </div>
                    <div class="section-title" :style="{ fontSize: secTitleFontSize + '!important' }">{{ sectionTitle }}
                    </div>

                    <div class="section-description" v-html="sectionDescription">
                    </div>
                    <div v-if=caseStudyLink class="case-study-link">
                        <router-link v-if="useRouterLink" :to="caseStudyPath"> {{ linkText }} </router-link>
                        <a v-else :href="caseStudyPath"> {{ linkText }}</a>
                    </div>
                </div>
            </template>

            <!-- Right Image -->

            <template v-if=!imageLeft>

                <div class="col-lg-6 ef-section">
                    <b-row class="mb-3 mt-sm-3" v-if=logo>
                        <div class="col-sm-4">
                            <div class="logo-img-left">
                                <img :src="logoPath" alt="" />
                            </div>
                        </div>
                        <div class="col-sm-8">
                            <div class="section-name-right" style="margin-top: 15px">
                                {{ sectionName }}
                            </div>
                        </div>
                    </b-row>

                    <div v-if=!logo class="section-name-right">{{ sectionName }} </div>
                    <div class="section-title" :style="{ fontSize: secTitleFontSize + '!important' }">{{ sectionTitle }}
                    </div>
                    <div class="section-description" v-html="sectionDescription">
                    </div>
                    <div v-if=caseStudyLink class="case-study-link">
                        <router-link v-if="useRouterLink" :to="caseStudyPath"> {{ linkText }} </router-link>
                        <a v-else :href="caseStudyPath"> {{ linkText }}</a>
                    </div>
                </div>
                
                <div class="col-lg-6 mt-5 order-lg-last order-first">
                    <div class="workout-img">
                        <img :src="imagePath" alt="" />
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>


export default {

    data: function () {
        return {

        };
    },
    methods: {
        redirectURL() {

        }
    },
    props: {
        sectionName: {
            type: String,
            default: null
        },
        sectionTitle: {
            type: String,
            default: null
        },
        sectionDescription: {
            type: String,
            default: null
        },
        imagePath: {
            type: String,
            default: null
        },
        logoPath: {
            type: String,
            default: null
        },
        caseStudyPath: {
            type: String,
            default: null
        },
        imageLeft: {
            type: Boolean,
            default: true
        },
        logo: {
            type: Boolean,
            default: false
        },
        caseStudyLink: {
            type: Boolean,
            default: false
        },
        linkText: {
            type: String,
            default: "READ THIS CASE STUDY >",
        },
        secTitleFontSize: {
            type: String,
            default: "48px !important",
        },
        paddingTop: {
            type: String,
            default: "20px !important",
        },
        useRouterLink: {
            type: Boolean, 
            default: true
        },
        container: {
            type: Boolean,
            default: true
        }
    },
};

</script>

<style lang="scss" scoped>
.section-name-left {
    font-size: 20px !important;
    line-height: 30px !important;
    font-weight: bold;
    color: #c4c4c4;
}

.section-name-right {
    font-size: 20px !important;
    line-height: 30px !important;
    margin-top: 25px;
    font-weight: bold;
    color: #c4c4c4;
}

.section-description {
    font-size: 20px !important;
    line-height: 30px !important;
}

.section-title {
    font-size: 48px !important;
    line-height: 134.5% !important;
}

.workout-img {
    display: flex;
    justify-content: center;

    img {
        border-radius: 25px;
        width: 100%;
        mix-blend-mode: multiply;
    }
}

.logo-img-right {
    display: flex;
    justify-content: center;

    img {
        width: 80%;
    }
}

.logo-img-left {
    display: flex;
    justify-content: center;

    img {
        width: 80%;
    }
}

.case-study-link {
    color: #73bc44;
    font-weight: bold;
    font-size: 15px;
    margin-top: 20px;
}

@media (max-width: 576px) and (orientation: portrait) {

    .section-name-left {
        font-size: 16px !important;
        line-height: 24px !important;
        margin-top: 60px !important;
    }

    .section-name-right {
        font-size: 16px !important;
        line-height: 24px !important;
        margin-top: 50px !important;
    }

    .motionImgPosition {
        display: flex;
    }

    .workout-img img {
        width: 100%;
        height: unset;
        justify-content: center;
    }

    .section-description {
        font-size: 16px !important;
        line-height: 24px !important;
    }

    .section-title {
        font-size: 36px !important;
        line-height: 134.5% !important;
    }

    .logo-img-right {
        display: flex;
        justify-content: center;

        img {
            width: 80%;
            padding-top: 30px;
        }
    }

    .logo-img-left {
        display: flex;
        justify-content: center;

        img {
            width: 80%;
            padding-top: 30px;
        }
    }

}

@media (max-width: 992px) and (orientation: landscape) {
    .motionImgPosition {
        display: flex;
    }

    .workout-img {
        width: 100%;
        justify-content: center;
    }

    .section-name-left,
    .section-description {
        font-size: 16px !important;
        line-height: 24px !important;
    }

    .section-title {
        font-size: 36px !important;
        line-height: 134.5% !important;
    }

}
</style>